/**
 * ExportModal — export options (production, preview, JSON, offerte)
 */
import { useState } from 'react';
import { useBuilderStore } from '@/state/store';
import { RenderIcon } from '@/components/preview/RenderIcon';
import { Modal } from './Modal';
import { exportProductionZip } from '@/generators/export/production';
import { generatePreviewHTML } from '@/generators/export/preview-html';
import { exportJsonBackup } from '@/generators/export/json-backup';
import { Toast } from '@/state/toast';

export function ExportModal() {
  const openModal = useBuilderStore((s) => s.openModal);
  const setOpenModal = useBuilderStore((s) => s.setOpenModal);
  const components = useBuilderStore((s) => s.components);
  const order = useBuilderStore((s) => s.order);
  const settings = useBuilderStore((s) => s.settings);

  const [selected, setSelected] = useState("production");

  const isOpen = openModal === 'export';
  const onClose = () => setOpenModal(null);

  const handleExport = async () => {
    try {
      switch (selected) {
        case "preview": {
          const html = generatePreviewHTML(components, order, settings);
          const blob = new Blob([html], { type: 'text/html' });
          const url = URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.href = url;
          a.download = 'preview.html';
          a.click();
          URL.revokeObjectURL(url);
          Toast.success('Preview-HTML exportiert');
          break;
        }
        case "production":
          await exportProductionZip(components, order, settings);
          break;
        case "json":
          exportJsonBackup(components, order, settings);
          Toast.success('JSON-Backup exportiert');
          break;
        case "offerte":
          setOpenModal('offerteGen');
          return; // Don't close
      }
    } catch (err: any) {
      if (err?.name !== 'AbortError') {
        Toast.error('Export fehlgeschlagen: ' + (err?.message || 'Unbekannter Fehler'));
      }
    }
    onClose();
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title="Projekt exportieren"
      footer={
        <>
          <button className="btn" onClick={onClose}>Abbrechen</button>
          <button className="btn btn-primary" onClick={handleExport}>
            <RenderIcon name="download" /> Exportieren
          </button>
        </>
      }
    >
      <div className="export-options">
        {[
          { key: 'production', icon: 'folder', title: 'Production Build', desc: 'Alle Dateien in Ordner exportieren' },
          { key: 'preview', icon: 'file', title: 'Quick Preview', desc: 'Eine HTML-Datei für schnelle Demo' },
          { key: 'json', icon: 'code', title: 'JSON Backup', desc: 'Konfiguration zum späteren Import' },
          { key: 'offerte', icon: 'file', title: 'Offerte Generator', desc: 'Standalone HTML-Tool mit deinen aktuellen Tokens & Firmendaten' },
        ].map((opt) => (
          <button
            key={opt.key}
            className={`export-option ${selected === opt.key ? "active" : ""}`}
            onClick={() => setSelected(opt.key)}
          >
            <div className="export-option-icon"><RenderIcon name={opt.icon} size={24} /></div>
            <div className="export-option-title">{opt.title}</div>
            <div className="export-option-desc">{opt.desc}</div>
          </button>
        ))}
      </div>
    </Modal>
  );
}
